import React from "react";

// COMPONENTS
import PDPImage from "../../shared/components/pdp-image";
import ModelIsWearingButton from "./model-is-wearing-button";
import VideoCarouselItem from "./video-carousel-item";

// CONSTANTS
import { IMAGE_TYPE } from "../utils/constants";

// STYLES
import styles from "../styles/carousel.module.scss";

const CarouselChildren = ({
  activeSlide,
  handleModelIsWearingButton,
  isMobile,
  mediaInfo,
  openZoomModal,
  pdpCarouselWWMTImageWidths,
  productImageAlt,
  renderShopThisLookButton,
  showModelIsWearingOverlay,
  shouldShowModelIsWearing,
  totalSlides,
  ModelIsWearingComponent,
  onSlideClick
}) =>
  mediaInfo?.map((image, index) => {
    const { type, posterImageUrl, url, key } = image;
    return type === IMAGE_TYPE ? (
      <div
        key={key}
        onClick={onSlideClick}
        className={styles.zoomButtonImageWrapper}
      >
        {shouldShowModelIsWearing && (
          <ModelIsWearingButton
            className={styles.modelIsWearingBtn}
            onClick={handleModelIsWearingButton}
            renderShopThisLookButton={renderShopThisLookButton}
            shouldRenderTagIcon={!isMobile}
          />
        )}
        {showModelIsWearingOverlay && ModelIsWearingComponent}
        <PDPImage
          lazy={index !== 0}
          src={url}
          className={styles.image}
          alt={productImageAlt}
          sizes={pdpCarouselWWMTImageWidths}
        />
      </div>
    ) : (
      <VideoCarouselItem
        key={key}
        {...{
          activeSlide,
          index,
          isMobile,
          openZoomModal,
          posterImageUrl,
          productImageAlt,
          pdpCarouselWWMTImageWidths,
          totalSlides,
          url
        }}
      />
    );
  });

export default CarouselChildren;
